import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import AgregarProducto from "./AgregarProducto.jsx";
import Globales from "utils/Globales";
import {
  Edit,
  ArrowBack,
  AddCircle,
  Save,
  Clear,
  Publish,
  GetApp,
} from "@material-ui/icons";
import Loader from "react-loader-spinner";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ReactLoading from "react-loading";
import Tooltip from "@material-ui/core/Tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import headerLinksStyle from "assets/jss/material-dashboard-react/components/headerLinksStyle.jsx";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

class DetalleProductoMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Datos del master
      master: null,
      variaciones: [],
      cargando: true,
      // Modo edición
      editandoMaster: false,
      editandoPrecio: false,
      // Campos editables del master
      NombreProductoEdit: "",
      TipoProductoEdit: "",
      DescripcionEdit: "",
      idCategoriaEdit: "",
      ImagenProductoEdit: null,
      NombreImagenProductoEdit: "",
      ImagenSubida: false,
      Categorias: [],
      // Campos editables de precio
      CostoMaterialEdit: 0,
      CostoMaquilaEdit: 0,
      TipoPrecioEdit: "",
      PorcentajeUtilidadEdit: 0,
      PrecioPublicoEdit: "",
      PrecioSinIvaEdit: "",
      valorIvaEdit: 0,
      PorcentajeComisionEdit: "",
      ImporteComisionEdit: "",
      ImporteUtilidadEdit: "",
      // Estados para el modal
      showAgregar: false,
      Titulo: "",
      _id: "",
      idCategoria: "",
      NombreProducto: "",
      TipoProducto: "",
      Descripcion: "",
      caracteristicasAgregadas: [],
      atributosAgregados: [],
      idModelo: "",
      idMateriaPrima: "",
      materialesAgregados: [],
      CostoMaterial: 0,
      CostoMaquila: 0,
      TipoPrecio: "",
      PorcentajeUtilidad: 0,
      PrecioPublico: 0,
      PrecioSinIva: "",
      PorcentajeComision: 0,
      ImporteComision: 0,
      IVA: 0,
      ImporteUtilidad: 0,
      PorcentajeUtilidadSistema: "",
      Peso: 0,
      Tamaño: "",
      ImagenProducto: null,
      NombreImagenProducto: "",
      NombreTempleteRecorte: "",
      NombreTextura: "",
      GruposMaterial: [],
      TabIndex: 0,
      op: 1,
      // Schemas
      Caracteristicas: [],
      Atributos: [],
      Modelos: [],
      MateriaPrima: [],
      Material: [],
      UnidadMedida: [],
      Empresa: [],
      // Notificaciones
      mensaje: "",
      br: false,
      colorNotificacion: "success",
      // Estados para el modal de generación de combinaciones
      showModalGenerarCombinaciones: false,
      atributosSeleccionados: [], // Array de { idAtributo, NombreAtributo, valoresSeleccionados: [] }
      combinacionesPreview: [], // Array con todas las combinaciones que se generarán
      generandoVariaciones: false, // Flag para mostrar loading
    };
    this.obtenerAllSchemas = this.obtenerAllSchemas.bind(this);
    this.obtenerMaster = this.obtenerMaster.bind(this);
    this.obtenerVariaciones = this.obtenerVariaciones.bind(this);
    this.editarVariacion = this.editarVariacion.bind(this);
    this.crearVariacion = this.crearVariacion.bind(this);
    this.eventoModalProducto = this.eventoModalProducto.bind(this);
    this.editarMaster = this.editarMaster.bind(this);
    this.cancelarEdicionMaster = this.cancelarEdicionMaster.bind(this);
    this.guardarMaster = this.guardarMaster.bind(this);
    this.handleChangeMaster = this.handleChangeMaster.bind(this);
    this.handleSimpleMaster = this.handleSimpleMaster.bind(this);
    this.editarPrecio = this.editarPrecio.bind(this);
    this.cancelarEdicionPrecio = this.cancelarEdicionPrecio.bind(this);
    this.guardarPrecio = this.guardarPrecio.bind(this);
    this.handleChangePrecio = this.handleChangePrecio.bind(this);
    this.handleSimplePrecio = this.handleSimplePrecio.bind(this);
    this.handlePorcentajeUtilidadEdit = this.handlePorcentajeUtilidadEdit.bind(
      this
    );
    this.handlePrecioPublicoEdit = this.handlePrecioPublicoEdit.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.publicarVariacion = this.publicarVariacion.bind(this);
    this.bajarVariacion = this.bajarVariacion.bind(this);
    this.abrirModalGenerarCombinaciones = this.abrirModalGenerarCombinaciones.bind(this);
    this.cerrarModalGenerarCombinaciones = this.cerrarModalGenerarCombinaciones.bind(this);
    this.toggleAtributoSeleccionado = this.toggleAtributoSeleccionado.bind(this);
    this.toggleValorAtributo = this.toggleValorAtributo.bind(this);
    this.calcularCombinaciones = this.calcularCombinaciones.bind(this);
    this.obtenerValoresAtributo = this.obtenerValoresAtributo.bind(this);
    this.generarVariacionesMasivas = this.generarVariacionesMasivas.bind(this);
  }

  componentDidMount() {
    const idMaster = this.props.match.params.id;
    if (idMaster) {
      this.obtenerAllSchemas();
      this.obtenerMaster(idMaster);
      this.obtenerVariaciones(idMaster);
      this.ObtenerCategorias();
    }
  }

  ObtenerCategorias() {
    fetch(Globales.Url + "Modelos/Categoria/ObtenerCategoriasPrincipales", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Categorias: data });
        }
      });
  }

  obtenerAllSchemas() {
    // Características
    fetch(Globales.Url + "Caracteristicas/Caracteristicas", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Caracteristicas: data.data });
        }
      });

    // Atributos
    fetch(Globales.Url + "Atributos/Atributos", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Atributos: data.mensaje });
        }
      });

    // Modelos
    fetch(Globales.Url + "Modelos/Modelos", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Modelos: data.data });
        }
      });

    // Materia Prima
    fetch(Globales.Url + "MateriaPrima/MateriaPrima", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ MateriaPrima: data.mensaje });
        }
      });

    // Material
    fetch(Globales.Url + "Material/Material", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Material: data.data });
        }
      });

    // Unidad Medida
    fetch(Globales.Url + "UnidadMedida/UnidadMedida", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ UnidadMedida: data.data });
        }
      });

    // Empresa
    fetch(Globales.Url + "Empresa/Empresa", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.error) {
          this.setState({ Empresa: data.data }, () => {
            // Actualizar valorIvaEdit si ya tenemos el master cargado
            if (
              this.state.master &&
              data.data &&
              data.data[0] &&
              data.data[0].ValorIVA !== undefined
            ) {
              this.setState({
                valorIvaEdit: data.data[0].ValorIVA,
              });
            }
          });
        }
      });
  }

  obtenerMaster(idMaster) {
    fetch(Globales.Url + "Productos/Productos/" + idMaster, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          this.setState({
            cargando: false,
            colorNotificacion: "danger",
            mensaje: "Error al obtener el producto master",
          });
          this.showNotification();
        } else {
          // Obtener URL de imagen (priorizar rutaImagenPublica)
          const imagenUrl = data.data.rutaImagenPublica
            ? data.data.rutaImagenPublica
            : data.data.ImagenProducto
            ? data.data.ImagenProducto.startsWith("data:")
              ? data.data.ImagenProducto
              : "data:image/png;base64," + data.data.ImagenProducto
            : null;

          this.setState({
            master: data.data,
            cargando: false,
            // Inicializar campos editables
            NombreProductoEdit: data.data.NombreProducto || "",
            TipoProductoEdit: data.data.TipoProducto || "",
            DescripcionEdit: data.data.Descripcion || "",
            idCategoriaEdit: data.data.idCategoria || "",
            ImagenProductoEdit: imagenUrl,
            NombreImagenProductoEdit: data.data.NombreImagenProducto || "",
            // Inicializar campos editables de precio
            CostoMaterialEdit: data.data.CostoMaterial || 0,
            CostoMaquilaEdit: data.data.CostoMaquila || 0,
            TipoPrecioEdit: data.data.TipoPrecio || "",
            PorcentajeUtilidadEdit: data.data.PorcentajeUtilidad || 0,
            PrecioPublicoEdit: data.data.PrecioPublico || "",
            PrecioSinIvaEdit: data.data.PrecioSinIva || "",
            valorIvaEdit:
              this.state.Empresa &&
              this.state.Empresa[0] &&
              this.state.Empresa[0].ValorIVA !== undefined
                ? this.state.Empresa[0].ValorIVA
                : data.data.IVA || 0,
            PorcentajeComisionEdit: data.data.PorcentajeComision || "",
            ImporteComisionEdit: data.data.ImporteComision || "",
            ImporteUtilidadEdit: data.data.ImporteUtilidad || "",
          });
        }
      })
      .catch((err) => {
        console.error("Error al obtener master:", err);
        this.setState({
          cargando: false,
          colorNotificacion: "danger",
          mensaje: "Error al obtener el producto master",
        });
        this.showNotification();
      });
  }

  obtenerVariaciones(idPadre) {
    fetch(Globales.Url + "Productos/Productos/ObtenerVariaciones", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({ idPadre: idPadre }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error) {
          this.setState({ variaciones: [] });
        } else {
          this.setState({ variaciones: data.data || [] });
        }
      })
      .catch((err) => {
        console.error("Error al obtener variaciones:", err);
        this.setState({ variaciones: [] });
      });
  }

  editarVariacion(variacion) {
    // Solo buscar ImagenProducto, si no hay valor ahí no pasa nada, solo no se verá la imagen
    const imagenUrl =
      variacion.ImagenProducto && variacion.ImagenProducto.trim() !== ""
        ? variacion.ImagenProducto
        : null;

    this.setState({
      _id: variacion._id,
      idCategoria: variacion.idCategoria,
      NombreProducto: variacion.NombreProducto,
      TipoProducto: variacion.TipoProducto,
      Descripcion: variacion.Descripcion,
      caracteristicasAgregadas: variacion.caracteristicasAgregadas || [],
      atributosAgregados: variacion.atributosAgregados || [],
      idModelo: variacion.idModelo,
      idMateriaPrima: variacion.idMateriaPrima,
      materialesAgregados: variacion.materialesAgregados || [],
      CostoMaterial: variacion.CostoMaterial || 0,
      CostoMaquila: variacion.CostoMaquila || 0,
      TipoPrecio: variacion.TipoPrecio || "",
      PorcentajeUtilidad: variacion.PorcentajeUtilidad || 0,
      PrecioPublico: variacion.PrecioPublico || "",
      PrecioSinIva: variacion.PrecioSinIva || "",
      PorcentajeComision: variacion.PorcentajeComision || "",
      ImporteComision: variacion.ImporteComision || "",
      ImporteUtilidad: variacion.ImporteUtilidad || "",
      Peso: variacion.Peso || 0,
      Tamaño: variacion.Tamano || "",
      IVA: variacion.IVA || 0,
      PorcentajeUtilidadSistema: variacion.PorcentajeUtilidadSistema || (this.state.Empresa && this.state.Empresa[0] ? Object.values(this.state.Empresa[0])[15] : ""),
      ImagenProducto: imagenUrl,
      NombreImagenProducto: variacion.NombreImagenProducto || "",
      NombreTempleteRecorte: variacion.NombreTempleteRecorte || "",
      NombreTextura: variacion.NombreTextura || "",
      GruposMaterial: variacion.GruposMaterial || [],
      Autorizado: variacion.Autorizado || false,
      TabIndex: 0,
      op: 1,
      showAgregar: true,
      Titulo: "Editar Variación",
      idPadre: variacion.idPadre,
      esVariacion: true,
    });
  }

  crearVariacion() {
    if (!this.state.master) return;

    this.setState({
      _id: "",
      idCategoria: this.state.master.idCategoria || "",
      NombreProducto: this.state.master.NombreProducto || "",
      TipoProducto: this.state.master.TipoProducto || "",
      Descripcion: this.state.master.Descripcion || "",
      caracteristicasAgregadas:
        this.state.master.caracteristicasAgregadas || [],
      atributosAgregados: this.state.master.atributosAgregados || [],
      idModelo: this.state.master.idModelo || null,
      idMateriaPrima: this.state.master.idMateriaPrima || "",
      materialesAgregados: this.state.master.materialesAgregados || [],
      CostoMaterial: this.state.master.CostoMaterial || 0,
      CostoMaquila: this.state.master.CostoMaquila || null,
      TipoPrecio: this.state.master.TipoPrecio || "",
      PorcentajeUtilidad: this.state.master.PorcentajeUtilidad || 0,
      PorcentajeUtilidadSistema:
        this.state.master.PorcentajeUtilidadSistema || 0,
      PrecioPublico: this.state.master.PrecioPublico || "",
      PrecioSinIva: this.state.master.PrecioSinIva || "",
      PorcentajeComision: this.state.master.PorcentajeComision || "",
      ImporteComision: this.state.master.ImporteComision || "",
      ImporteUtilidad: this.state.master.ImporteUtilidad || "",
      Peso: this.state.master.Peso || "",
      Tamaño: "", // El tamaño se deja vacío para que el usuario lo seleccione
      IVA: this.state.master.IVA || 0,
      ImagenProducto: this.state.master.ImagenProducto || null,
      NombreImagenProducto: this.state.master.NombreImagenProducto || "",
      NombreTempleteRecorte: this.state.master.NombreTempleteRecorte || "",
      NombreTextura: this.state.master.NombreTextura || "",
      GruposMaterial: this.state.master.GruposMaterial || [],
      TabIndex: 0,
      op: 0,
      ProductoNuevo: false, // Mostrar todos los tabs aunque sea nuevo (porque es variación)
      showAgregar: true,
      Titulo: "Nueva Variación",
      idPadre: this.state.master._id,
      esVariacion: true,
    });
  }

  eventoModalProducto(mensaje, colorNotificacion) {
    if (mensaje !== "esc") {
      this.setState({
        mensaje: mensaje,
        colorNotificacion: colorNotificacion,
      });
      this.showNotification();
      // Recargar variaciones
      const idMaster = this.props.match.params.id;
      if (idMaster) {
        this.obtenerVariaciones(idMaster);
      }
    }
    // Limpiar todos los estados relacionados con el modal de edición
    this.setState({
      showAgregar: false,
      Titulo: "",
      op: 0,
      _id: "",
      idCategoria: "",
      NombreProducto: "",
      TipoProducto: "",
      Descripcion: "",
      caracteristicasAgregadas: [],
      atributosAgregados: [],
      idModelo: "",
      idMateriaPrima: "",
      materialesAgregados: [],
      CostoMaterial: 0,
      CostoMaquila: 0,
      TipoPrecio: "",
      PorcentajeUtilidad: 0,
      PrecioPublico: 0,
      PrecioSinIva: 0,
      PorcentajeComision: 0,
      ImporteComision: 0,
      IVA: 0,
      ImporteUtilidad: 0,
      Peso: 0,
      Tamaño: "",
      ImagenProducto: null,
      NombreImagenProducto: "",
      NombreTempleteRecorte: "",
      NombreTextura: "",
      GruposMaterial: [],
      TabIndex: 0,
      idPadre: null,
      esVariacion: false,
      ProductoNuevo: false,
    });
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function() {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  obtenerNombreMateriaPrima(idMateria) {
    var nombre = "";
    this.state.MateriaPrima.map((materia) => {
      if (idMateria == materia._id) {
        nombre = materia.NombreMateria;
      }
    });
    return nombre;
  }

  obtenerNombreTalla(idTalla) {
    // Esta función debería obtener el nombre de la talla
    // Por ahora retornamos el ID
    return idTalla || "N/A";
  }

  editarMaster() {
    this.setState({ editandoMaster: true });
  }

  cancelarEdicionMaster() {
    if (this.state.master) {
      // Obtener URL de imagen (priorizar rutaImagenPublica)
      const imagenUrl = this.state.master.rutaImagenPublica
        ? this.state.master.rutaImagenPublica
        : this.state.master.ImagenProducto
        ? this.state.master.ImagenProducto.startsWith("data:")
          ? this.state.master.ImagenProducto
          : "data:image/png;base64," + this.state.master.ImagenProducto
        : null;

      this.setState({
        editandoMaster: false,
        NombreProductoEdit: this.state.master.NombreProducto || "",
        TipoProductoEdit: this.state.master.TipoProducto || "",
        DescripcionEdit: this.state.master.Descripcion || "",
        idCategoriaEdit: this.state.master.idCategoria || "",
        ImagenProductoEdit: imagenUrl,
        NombreImagenProductoEdit: this.state.master.NombreImagenProducto || "",
        ImagenSubida: false,
      });
    }
  }

  getFiles(event) {
    var origen = event.target.name;
    this.setState({
      [origen + "Subida"]: true,
    });
    var preview = document.getElementById(origen + "Preview");
    var file = document.getElementById(origen).files[0];
    var reader = new FileReader();
    reader.onloadend = () => {
      var base64 = reader.result;
      if (origen == "ImagenProductoEdit") {
        if (preview) {
          preview.src = base64;
        }
        this.setState({
          NombreImagenProductoEdit: file.name,
          ImagenProductoEdit: base64,
          [origen + "Subida"]: false,
        });
      }
    };

    if (file) {
      reader.readAsDataURL(file);
    } else {
      if (preview) {
        preview.src = "";
      }
    }
  }

  handleChangeMaster(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSimpleMaster(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  guardarMaster() {
    if (!this.state.master) return;

    // Validaciones básicas
    if (!this.state.NombreProductoEdit.trim()) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "El nombre del producto es requerido",
      });
      this.showNotification();
      return;
    }
    if (!this.state.DescripcionEdit.trim()) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "La descripción es requerida",
      });
      this.showNotification();
      return;
    }
    if (!this.state.TipoProductoEdit) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "El tipo de producto es requerido",
      });
      this.showNotification();
      return;
    }
    if (!this.state.idCategoriaEdit) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "La categoría es requerida",
      });
      this.showNotification();
      return;
    }

    // Obtener todos los datos del master para actualizar
    fetch(Globales.Url + "Productos/Productos/" + this.state.master._id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error || !data.data) {
          this.setState({
            colorNotificacion: "danger",
            mensaje: "Error al obtener datos del producto",
          });
          this.showNotification();
        } else {
          const productoCompleto = data.data;

          // Actualizar solo los campos básicos
          fetch(Globales.Url + "Productos/Productos/ActualizarProducto", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: Globales.token,
            },
            body: JSON.stringify({
              _id: this.state.master._id,
              NombreProducto: this.state.NombreProductoEdit,
              TipoProducto: this.state.TipoProductoEdit,
              Descripcion: this.state.DescripcionEdit,
              Tamano: productoCompleto.Tamano,
              ImagenProducto: this.state.ImagenProductoEdit
                ? this.state.ImagenProductoEdit.startsWith("data:image")
                  ? this.state.ImagenProductoEdit.split(",")[1]
                  : this.state.ImagenProductoEdit.replace(
                      /^data:image\/\w+;base64,/,
                      ""
                    )
                : productoCompleto.ImagenProducto,
              NombreImagenProducto:
                this.state.NombreImagenProductoEdit ||
                productoCompleto.NombreImagenProducto,
              TexturaProducto: productoCompleto.TexturaProducto,
              NombreTextura: productoCompleto.NombreTextura,
              TempleteRecorte: productoCompleto.TempleteRecorte,
              NombreTempleteRecorte: productoCompleto.NombreTempleteRecorte,
              caracteristicasAgregadas:
                productoCompleto.caracteristicasAgregadas || [],
              atributosAgregados: productoCompleto.atributosAgregados || [],
              idModelo: productoCompleto.idModelo,
              idMateriaPrima: productoCompleto.idMateriaPrima,
              materialesAgregados: productoCompleto.materialesAgregados || [],
              CostoMaterial: productoCompleto.CostoMaterial || 0,
              CostoMaquila: productoCompleto.CostoMaquila || 0,
              TipoPrecio: productoCompleto.TipoPrecio || "",
              PorcentajeUtilidad: productoCompleto.PorcentajeUtilidad || 0,
              PrecioPublico: productoCompleto.PrecioPublico || 0,
              PorcentajeComision: productoCompleto.PorcentajeComision || 0,
              ImporteComision: productoCompleto.ImporteComision || 0,
              ImporteUtilidad: productoCompleto.ImporteUtilidad || 0,
              Peso: productoCompleto.Peso || 0,
              PorcentajeUtilidadSistema:
                productoCompleto.PorcentajeUtilidadSistema || 0,
              PrecioSinIva: productoCompleto.PrecioSinIva || 0,
              IVA: productoCompleto.IVA || 0,
              idCategoria: this.state.idCategoriaEdit,
              GruposMaterial: productoCompleto.GruposMaterial || [],
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.error) {
                this.setState({
                  colorNotificacion: "danger",
                  mensaje: data.mensaje || "Error al actualizar el producto",
                });
                this.showNotification();
              } else {
                this.setState({
                  colorNotificacion: "success",
                  mensaje: "Producto actualizado correctamente",
                  editandoMaster: false,
                });
                this.showNotification();
                // Recargar datos del master
                this.obtenerMaster(this.state.master._id);
              }
            })
            .catch((err) => {
              console.error("Error al actualizar master:", err);
              this.setState({
                colorNotificacion: "danger",
                mensaje: "Error al actualizar el producto",
              });
              this.showNotification();
            });
        }
      })
      .catch((err) => {
        console.error("Error al obtener master completo:", err);
        this.setState({
          colorNotificacion: "danger",
          mensaje: "Error al obtener datos del producto",
        });
        this.showNotification();
      });
  }

  editarPrecio() {
    // Verificar si hay variaciones y mostrar advertencia
    if (this.state.variaciones.length > 0) {
      if (
        window.confirm(
          `Este producto tiene ${
            this.state.variaciones.length
          } variación(es). ` +
            `Los cambios en el precio se aplicarán a todas las variaciones. ` +
            `¿Desea continuar?`
        )
      ) {
        this.setState({ editandoPrecio: true });
      }
    } else {
      this.setState({ editandoPrecio: true });
    }
  }

  cancelarEdicionPrecio() {
    if (this.state.master) {
      this.setState({
        editandoPrecio: false,
        CostoMaterialEdit: this.state.master.CostoMaterial || 0,
        CostoMaquilaEdit: this.state.master.CostoMaquila || 0,
        TipoPrecioEdit: this.state.master.TipoPrecio || "",
        PorcentajeUtilidadEdit: this.state.master.PorcentajeUtilidad || 0,
        PrecioPublicoEdit: this.state.master.PrecioPublico || "",
        PrecioSinIvaEdit: this.state.master.PrecioSinIva || "",
        valorIvaEdit:
          this.state.Empresa &&
          this.state.Empresa[0] &&
          this.state.Empresa[0].ValorIVA !== undefined
            ? this.state.Empresa[0].ValorIVA
            : this.state.master.IVA || 0,
        PorcentajeComisionEdit: this.state.master.PorcentajeComision || "",
        ImporteComisionEdit: this.state.master.ImporteComision || "",
        ImporteUtilidadEdit: this.state.master.ImporteUtilidad || "",
      });
    }
  }

  handleChangePrecio(e) {
    const { name, value } = e.target;

    // Si cambia PorcentajeComision, calcular ImporteComision
    if (name === "PorcentajeComisionEdit" && this.state.PrecioPublicoEdit) {
      const comision =
        Number(this.state.PrecioPublicoEdit) * (Number(value) / 100);
      this.setState({
        [name]: value,
        ImporteComisionEdit: comision.toFixed(2),
      });
      return;
    }

    this.setState({ [name]: value });
  }

  handleSimplePrecio(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handlePorcentajeUtilidadEdit(e) {
    const value = e.target.value;

    // Validar que hayan ingresado costo material y maquila
    if (!this.state.CostoMaterialEdit || this.state.CostoMaterialEdit === "") {
      return;
    }
    if (!this.state.CostoMaquilaEdit || this.state.CostoMaquilaEdit === "") {
      return;
    }

    // Validar rango
    if (Number(value) < 0 || Number(value) > 99) {
      return;
    }

    // Obtener IVA
    const valorIva =
      this.state.Empresa &&
      this.state.Empresa[0] &&
      this.state.Empresa[0].ValorIVA
        ? this.state.Empresa[0].ValorIVA
        : this.state.valorIvaEdit || 0;

    // Calcular costo total
    const costo =
      Number(this.state.CostoMaterialEdit) +
      Number(this.state.CostoMaquilaEdit);
    const porcentajeCosto = 100 - Number(value);
    const subtotal = Number(costo) / (Number(porcentajeCosto) / 100);
    const iva = (Number(subtotal) * (Number(valorIva) / 100)).toFixed(2);
    const precioPublico = Number(subtotal) + Number(iva);
    const importeUtilidad = Number(subtotal) * (Number(value) / 100);
    const importeUtilidadRedondeado = Math.round(importeUtilidad * 100) / 100;

    // Calcular ImporteComision si hay PorcentajeComision
    let importeComision = Number(this.state.ImporteComisionEdit) || 0;
    if (this.state.PorcentajeComisionEdit) {
      importeComision =
        Number(precioPublico) *
        (Number(this.state.PorcentajeComisionEdit) / 100);
    }
    // Asegurar que importeComision sea un número
    importeComision = Number(importeComision) || 0;

    this.setState({
      PorcentajeUtilidadEdit: value,
      PrecioPublicoEdit: precioPublico.toFixed(2),
      PrecioSinIvaEdit: subtotal.toFixed(2),
      valorIvaEdit: iva,
      ImporteUtilidadEdit: importeUtilidadRedondeado.toFixed(2),
      ImporteComisionEdit: importeComision.toFixed(2),
    });
  }

  handlePrecioPublicoEdit(e) {
    const value = e.target.value;

    // Obtener IVA
    const valorIva =
      this.state.Empresa &&
      this.state.Empresa[0] &&
      this.state.Empresa[0].ValorIVA
        ? this.state.Empresa[0].ValorIVA
        : this.state.valorIvaEdit || 0;

    // Calcular precio sin IVA
    const precioSinIvaFactor = Number(valorIva) / 100 + 1;
    const precioSinIva = Number(value) / Number(precioSinIvaFactor);
    const iva = (Number(value) - Number(precioSinIva)).toFixed(2);

    // Calcular PorcentajeUtilidad e ImporteUtilidad si hay CostoMaterial y CostoMaquila
    let porcentajeUtilidad = "";
    let importeUtilidad = 0;

    if (this.state.CostoMaterialEdit && this.state.CostoMaquilaEdit) {
      const costoTotal =
        Number(this.state.CostoMaterialEdit) +
        Number(this.state.CostoMaquilaEdit);
      porcentajeUtilidad = Number(costoTotal) / Number(precioSinIva);
      porcentajeUtilidad = 1 - Number(porcentajeUtilidad);
      porcentajeUtilidad = Number(porcentajeUtilidad) * 100;
      porcentajeUtilidad = Math.round(porcentajeUtilidad);

      importeUtilidad = Number(porcentajeUtilidad) / 100;
      importeUtilidad = Number(precioSinIva) * Number(importeUtilidad);
      importeUtilidad = Math.round(importeUtilidad * 100) / 100;
    }

    // Calcular ImporteComision si hay PorcentajeComision
    let importeComision = Number(this.state.ImporteComisionEdit) || 0;
    if (this.state.PorcentajeComisionEdit) {
      importeComision =
        Number(value) * (Number(this.state.PorcentajeComisionEdit) / 100);
    }
    // Asegurar que importeComision sea un número
    importeComision = Number(importeComision) || 0;

    this.setState({
      PrecioPublicoEdit: value,
      PrecioSinIvaEdit: precioSinIva.toFixed(2),
      valorIvaEdit: iva,
      PorcentajeUtilidadEdit:
        porcentajeUtilidad !== ""
          ? porcentajeUtilidad
          : this.state.PorcentajeUtilidadEdit,
      ImporteUtilidadEdit:
        importeUtilidad > 0
          ? importeUtilidad.toFixed(2)
          : this.state.ImporteUtilidadEdit,
      ImporteComisionEdit: importeComision.toFixed(2),
    });
  }

  guardarPrecio() {
    if (!this.state.master) return;

    // Validaciones básicas
    if (
      this.state.TipoPrecioEdit === "PorcentajeUtilidad" &&
      !this.state.PorcentajeUtilidadEdit
    ) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "El porcentaje de utilidad es requerido",
      });
      this.showNotification();
      return;
    }

    if (!this.state.PrecioPublicoEdit) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "El precio público es requerido",
      });
      this.showNotification();
      return;
    }

    // Obtener todos los datos del master para actualizar
    fetch(Globales.Url + "Productos/Productos/" + this.state.master._id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.error || !data.data) {
          this.setState({
            colorNotificacion: "danger",
            mensaje: "Error al obtener datos del producto",
          });
          this.showNotification();
        } else {
          const productoCompleto = data.data;

          // Actualizar el master
          fetch(Globales.Url + "Productos/Productos/ActualizarProducto", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: Globales.token,
            },
            body: JSON.stringify({
              _id: this.state.master._id,
              NombreProducto: productoCompleto.NombreProducto,
              TipoProducto: productoCompleto.TipoProducto,
              Descripcion: productoCompleto.Descripcion,
              Tamano: productoCompleto.Tamano,
              ImagenProducto: productoCompleto.ImagenProducto,
              NombreImagenProducto: productoCompleto.NombreImagenProducto,
              TexturaProducto: productoCompleto.TexturaProducto,
              NombreTextura: productoCompleto.NombreTextura,
              TempleteRecorte: productoCompleto.TempleteRecorte,
              NombreTempleteRecorte: productoCompleto.NombreTempleteRecorte,
              caracteristicasAgregadas:
                productoCompleto.caracteristicasAgregadas || [],
              atributosAgregados: productoCompleto.atributosAgregados || [],
              idModelo: productoCompleto.idModelo,
              idMateriaPrima: productoCompleto.idMateriaPrima,
              materialesAgregados: productoCompleto.materialesAgregados || [],
              CostoMaterial: this.state.CostoMaterialEdit || 0,
              CostoMaquila: this.state.CostoMaquilaEdit || 0,
              TipoPrecio: this.state.TipoPrecioEdit,
              PorcentajeUtilidad: this.state.PorcentajeUtilidadEdit || 0,
              PrecioPublico: this.state.PrecioPublicoEdit,
              PorcentajeComision: this.state.PorcentajeComisionEdit || "",
              ImporteComision: this.state.ImporteComisionEdit || "",
              ImporteUtilidad: this.state.ImporteUtilidadEdit || "",
              Peso: productoCompleto.Peso || 0,
              PorcentajeUtilidadSistema:
                productoCompleto.PorcentajeUtilidadSistema || 0,
              PrecioSinIva: this.state.PrecioSinIvaEdit || "",
              IVA: this.state.valorIvaEdit || 0,
              idCategoria: productoCompleto.idCategoria,
              GruposMaterial: productoCompleto.GruposMaterial || [],
            }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.error) {
                this.setState({
                  colorNotificacion: "danger",
                  mensaje: data.mensaje || "Error al actualizar el producto",
                });
                this.showNotification();
              } else {
                // Actualizar todas las variaciones
                const actualizarVariaciones = this.state.variaciones.map(
                  (variacion) => {
                    return fetch(
                      Globales.Url + "Productos/Productos/" + variacion._id,
                      {
                        method: "GET",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                          Authorization: Globales.token,
                        },
                      }
                    )
                      .then((res) => res.json())
                      .then((variacionData) => {
                        if (!variacionData.error && variacionData.data) {
                          const variacionCompleta = variacionData.data;
                          console.log(`[guardarPrecio] Actualizando variación ${variacion._id} con precio:`, {
                            PrecioPublico: this.state.PrecioPublicoEdit,
                            CostoMaterial: this.state.CostoMaterialEdit,
                            CostoMaquila: this.state.CostoMaquilaEdit
                          });
                          return fetch(
                            Globales.Url +
                              "Productos/Productos/ActualizarProducto",
                            {
                              method: "POST",
                              headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                                Authorization: Globales.token,
                              },
                              body: JSON.stringify({
                                _id: variacion._id,
                                NombreProducto:
                                  variacionCompleta.NombreProducto,
                                TipoProducto: variacionCompleta.TipoProducto,
                                Descripcion: variacionCompleta.Descripcion,
                                Tamano: variacionCompleta.Tamano,
                                ImagenProducto:
                                  variacionCompleta.ImagenProducto,
                                NombreImagenProducto:
                                  variacionCompleta.NombreImagenProducto,
                                TexturaProducto:
                                  variacionCompleta.TexturaProducto,
                                NombreTextura: variacionCompleta.NombreTextura,
                                TempleteRecorte:
                                  variacionCompleta.TempleteRecorte,
                                NombreTempleteRecorte:
                                  variacionCompleta.NombreTempleteRecorte,
                                caracteristicasAgregadas:
                                  variacionCompleta.caracteristicasAgregadas ||
                                  [],
                                atributosAgregados:
                                  variacionCompleta.atributosAgregados || [],
                                idModelo: variacionCompleta.idModelo,
                                idMateriaPrima:
                                  variacionCompleta.idMateriaPrima,
                                materialesAgregados:
                                  variacionCompleta.materialesAgregados || [],
                                CostoMaterial:
                                  this.state.CostoMaterialEdit || 0,
                                CostoMaquila: this.state.CostoMaquilaEdit || 0,
                                TipoPrecio: this.state.TipoPrecioEdit,
                                PorcentajeUtilidad:
                                  this.state.PorcentajeUtilidadEdit || 0,
                                PrecioPublico: this.state.PrecioPublicoEdit,
                                PorcentajeComision:
                                  this.state.PorcentajeComisionEdit || "",
                                ImporteComision:
                                  this.state.ImporteComisionEdit || "",
                                ImporteUtilidad:
                                  this.state.ImporteUtilidadEdit || "",
                                Peso: variacionCompleta.Peso || 0,
                                PorcentajeUtilidadSistema:
                                  variacionCompleta.PorcentajeUtilidadSistema ||
                                  0,
                                PrecioSinIva: this.state.PrecioSinIvaEdit || "",
                                IVA: this.state.valorIvaEdit || 0,
                                idCategoria: variacionCompleta.idCategoria,
                                GruposMaterial:
                                  variacionCompleta.GruposMaterial || [],
                              }),
                            }
                          )
                          .then((res) => res.json())
                          .then((updateResult) => {
                            if (updateResult.error) {
                              console.error(`[guardarPrecio] Error al actualizar variación ${variacion._id}:`, updateResult.mensaje);
                            } else {
                              console.log(`[guardarPrecio] Variación ${variacion._id} actualizada correctamente`);
                            }
                            return updateResult;
                          });
                        } else {
                          console.error(`[guardarPrecio] Error al obtener variación ${variacion._id}:`, variacionData);
                          return Promise.resolve({ error: true, mensaje: "Error al obtener variación" });
                        }
                      });
                  }
                );

                Promise.all(actualizarVariaciones)
                  .then(() => {
                    this.setState({
                      colorNotificacion: "success",
                      mensaje: `Producto y ${
                        this.state.variaciones.length
                      } variación(es) actualizados correctamente`,
                      editandoPrecio: false,
                    });
                    this.showNotification();
                    // Recargar datos del master y variaciones
                    this.obtenerMaster(this.state.master._id);
                    this.obtenerVariaciones(this.state.master._id);
                  })
                  .catch((err) => {
                    console.error("Error al actualizar variaciones:", err);
                    this.setState({
                      colorNotificacion: "warning",
                      mensaje:
                        "Producto actualizado, pero hubo errores al actualizar algunas variaciones",
                      editandoPrecio: false,
                    });
                    this.showNotification();
                    // Recargar datos de todos modos
                    this.obtenerMaster(this.state.master._id);
                    this.obtenerVariaciones(this.state.master._id);
                  });
              }
            })
            .catch((err) => {
              console.error("Error al actualizar master:", err);
              this.setState({
                colorNotificacion: "danger",
                mensaje: "Error al actualizar el producto",
              });
              this.showNotification();
            });
        }
      })
      .catch((err) => {
        console.error("Error al obtener master completo:", err);
        this.setState({
          colorNotificacion: "danger",
          mensaje: "Error al obtener datos del producto",
        });
        this.showNotification();
      });
  }

  publicarVariacion(variacion) {
    // Validar campos requeridos
    // Si la variación no tiene rutaImagenPublica, verificar si el master lo tiene
    let rutaImagenPublica = variacion.rutaImagenPublica;
    let necesitaActualizarImagen = false;
    
    if (!rutaImagenPublica || rutaImagenPublica === "") {
      if (this.state.master && this.state.master.rutaImagenPublica && this.state.master.rutaImagenPublica !== "") {
        // El master tiene rutaImagenPublica, usar la del master
        rutaImagenPublica = this.state.master.rutaImagenPublica;
        necesitaActualizarImagen = true;
      } else {
        // Ni la variación ni el master tienen rutaImagenPublica
        this.setState({
          colorNotificacion: "danger",
          mensaje:
            "La variación debe tener una imagen pública (rutaImagenPublica). El producto master tampoco tiene una imagen pública.",
        });
        this.showNotification();
        return;
      }
    }

    if (
      !variacion.NombreTempleteRecorte ||
      variacion.NombreTempleteRecorte === ""
    ) {
      this.setState({
        colorNotificacion: "danger",
        mensaje:
          "La variación debe tener un template de recorte (NombreTempleteRecorte)",
      });
      this.showNotification();
      return;
    }

    if (!variacion.PrecioPublico || variacion.PrecioPublico === 0) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "La variación debe tener un precio público",
      });
      this.showNotification();
      return;
    }

    // Si necesita actualizar la imagen, hacerlo primero
    const actualizarImagenSiEsNecesario = () => {
      if (necesitaActualizarImagen) {
        return fetch(Globales.Url + "Productos/Productos/ActualizarProducto", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: Globales.token,
          },
          body: JSON.stringify({
            _id: variacion._id,
            rutaImagenPublica: rutaImagenPublica,
          }),
        })
          .then((res) => res.json())
          .then((updateData) => {
            if (updateData.error) {
              console.error("Error al actualizar rutaImagenPublica:", updateData.mensaje);
            }
            return Promise.resolve();
          })
          .catch((err) => {
            console.error("Error al actualizar rutaImagenPublica:", err);
            return Promise.resolve(); // Continuar aunque falle
          });
      }
      return Promise.resolve();
    };

    // Verificar que tenga al menos 1 capa en CapaProducto
    actualizarImagenSiEsNecesario()
      .then(() => {
        return fetch(Globales.Url + "Productos/Productos/ObtenerCapasPorProducto", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: Globales.token,
          },
          body: JSON.stringify({ idProducto: variacion._id }),
        });
      })
      .then((res) => res.json())
      .then((data) => {
        if (data.error || !data.data || data.data.length === 0) {
          this.setState({
            colorNotificacion: "danger",
            mensaje: "La variación debe tener al menos 1 capa registrada",
          });
          this.showNotification();
        } else {
          // Actualizar la variación con Autorizado: true
          fetch(Globales.Url + "Productos/Productos/ActualizarAutorizado", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: Globales.token,
            },
            body: JSON.stringify({
              _id: variacion._id,
              Autorizado: true,
            }),
          })
            .then((res) => res.json())
            .then((updateData) => {
              if (updateData.error) {
                this.setState({
                  colorNotificacion: "danger",
                  mensaje:
                    updateData.mensaje || "Error al publicar la variación",
                });
                this.showNotification();
              } else {
                // Actualizar el master también
                if (variacion.idPadre) {
                  fetch(
                    Globales.Url + "Productos/Productos/ActualizarAutorizado",
                    {
                      method: "POST",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: Globales.token,
                      },
                      body: JSON.stringify({
                        _id: variacion.idPadre,
                        Autorizado: true,
                      }),
                    }
                  )
                    .then((res) => res.json())
                    .then((masterUpdateData) => {
                      if (masterUpdateData.error) {
                        this.setState({
                          colorNotificacion: "warning",
                          mensaje:
                            "Variación publicada, pero error al actualizar el master",
                        });
                        this.showNotification();
                      } else {
                        this.setState({
                          colorNotificacion: "success",
                          mensaje: "Variación publicada correctamente",
                        });
                        this.showNotification();
                      }
                      // Recargar datos
                      this.obtenerMaster(variacion.idPadre);
                      this.obtenerVariaciones(variacion.idPadre);
                    })
                    .catch((err) => {
                      console.error("Error al actualizar master:", err);
                      this.setState({
                        colorNotificacion: "warning",
                        mensaje:
                          "Variación publicada, pero error al actualizar el master",
                      });
                      this.showNotification();
                      // Recargar datos de todos modos
                      this.obtenerMaster(variacion.idPadre);
                      this.obtenerVariaciones(variacion.idPadre);
                    });
                } else {
                  // No hay idPadre, solo recargar variaciones
                  this.setState({
                    colorNotificacion: "success",
                    mensaje: "Variación publicada correctamente",
                  });
                  this.showNotification();
                }
              }
            })
            .catch((err) => {
              console.error("Error al actualizar variación:", err);
              this.setState({
                colorNotificacion: "danger",
                mensaje: "Error al publicar la variación",
              });
              this.showNotification();
            });
        }
      })
      .catch((err) => {
        console.error("Error al verificar capas:", err);
        this.setState({
          colorNotificacion: "danger",
          mensaje: "Error al verificar las capas del producto",
        });
        this.showNotification();
      });
  }

  // ========== MÉTODOS PARA GENERACIÓN DE COMBINACIONES ==========
  
  abrirModalGenerarCombinaciones() {
    if (!this.state.master) return;
    
    // Filtrar atributos que pertenecen a la categoría del master
    const idCategoriaMaster = this.state.master.idCategoria 
      ? this.state.master.idCategoria.toString() 
      : null;
    
    const atributosDisponibles = this.state.Atributos.filter(atributo => {
      if (!atributo.idCategorias || !Array.isArray(atributo.idCategorias)) return false;
      if (!idCategoriaMaster) return false;
      return atributo.idCategorias.includes(idCategoriaMaster);
    });

    // Inicializar atributos seleccionados vacíos
    const atributosIniciales = atributosDisponibles.map(atributo => ({
      idAtributo: atributo._id,
      NombreAtributo: atributo.NombreAtributo,
      valoresDisponibles: this.obtenerValoresAtributo(atributo),
      valoresSeleccionados: [],
      seleccionado: false
    }));

    this.setState({
      showModalGenerarCombinaciones: true,
      atributosSeleccionados: atributosIniciales,
      combinacionesPreview: []
    });
  }

  cerrarModalGenerarCombinaciones() {
    this.setState({
      showModalGenerarCombinaciones: false,
      atributosSeleccionados: [],
      combinacionesPreview: []
    });
  }

  obtenerValoresAtributo(atributo) {
    const valores = [];
    
    // Si es tipo Desplegable
    if (atributo.Tipo && Array.isArray(atributo.Tipo) && atributo.Tipo.length > 0) {
      const tipo = atributo.Tipo[0];
      
      if (tipo.Desplegable && Array.isArray(tipo.Desplegable) && tipo.Desplegable.length > 0) {
        const desplegable = tipo.Desplegable[0];
        if (desplegable.Valor && Array.isArray(desplegable.Valor)) {
          desplegable.Valor.forEach(valor => {
            valores.push({
              tipo: 'desplegable',
              valor: valor,
              label: valor
            });
          });
        }
      }
      
      // Si es tipo Color
      if (tipo.Color) {
        valores.push({
          tipo: 'color',
          valor: tipo.Color,
          label: tipo.Color
        });
      }
    }
    
    return valores;
  }

  toggleAtributoSeleccionado(idAtributo) {
    const atributosActualizados = this.state.atributosSeleccionados.map(atributo => {
      if (atributo.idAtributo === idAtributo) {
        const nuevoEstado = !atributo.seleccionado;
        return {
          ...atributo,
          seleccionado: nuevoEstado,
          valoresSeleccionados: nuevoEstado ? [] : atributo.valoresSeleccionados // Limpiar valores si se deselecciona
        };
      }
      return atributo;
    });

    this.setState({ atributosSeleccionados: atributosActualizados }, () => {
      this.calcularCombinaciones();
    });
  }

  toggleValorAtributo(idAtributo, valor) {
    const atributosActualizados = this.state.atributosSeleccionados.map(atributo => {
      if (atributo.idAtributo === idAtributo) {
        const valoresActuales = atributo.valoresSeleccionados || [];
        const existeValor = valoresActuales.includes(valor);
        
        const nuevosValores = existeValor
          ? valoresActuales.filter(v => v !== valor)
          : [...valoresActuales, valor];

        return {
          ...atributo,
          valoresSeleccionados: nuevosValores
        };
      }
      return atributo;
    });

    this.setState({ atributosSeleccionados: atributosActualizados }, () => {
      this.calcularCombinaciones();
    });
  }

  calcularCombinaciones() {
    const { atributosSeleccionados } = this.state;
    
    // Filtrar solo atributos seleccionados con valores
    const atributosConValores = atributosSeleccionados.filter(
      attr => attr.seleccionado && attr.valoresSeleccionados && attr.valoresSeleccionados.length > 0
    );
    
    if (atributosConValores.length === 0) {
      this.setState({ combinacionesPreview: [] });
      return;
    }
    
    // Producto cartesiano
    let combinaciones = [{}];
    
    atributosConValores.forEach(atributo => {
      const nuevasCombinaciones = [];
      combinaciones.forEach(combinacion => {
        atributo.valoresSeleccionados.forEach(valor => {
          nuevasCombinaciones.push({
            ...combinacion,
            [atributo.idAtributo]: {
              idAtributo: atributo.idAtributo,
              NombreAtributo: atributo.NombreAtributo,
              valor: valor
            }
          });
        });
      });
      combinaciones = nuevasCombinaciones;
    });
    
    this.setState({ combinacionesPreview: combinaciones });
  }

  generarVariacionesMasivas() {
    if (!this.state.master || !this.state.combinacionesPreview || this.state.combinacionesPreview.length === 0) {
      this.setState({
        colorNotificacion: "danger",
        mensaje: "No hay combinaciones para generar",
      });
      this.showNotification();
      return;
    }

    // Convertir combinacionesPreview al formato esperado por el backend
    const combinaciones = this.state.combinacionesPreview.map(combinacion => {
      // combinacion es un objeto con keys = idAtributo y valores = {idAtributo, NombreAtributo, valor}
      return combinacion;
    });

    console.log("📤 Enviando combinaciones al backend:", {
      total: combinaciones.length,
      combinaciones: combinaciones
    });

    // Mostrar loading
    this.setState({
      generandoVariaciones: true,
      colorNotificacion: "info",
      mensaje: "Generando variaciones...",
    });
    this.showNotification();

    fetch(Globales.Url + "Productos/Productos/GenerarVariacionesPorCombinaciones", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({
        idPadre: this.state.master._id,
        combinaciones: combinaciones
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({ generandoVariaciones: false });
        
        if (data.error) {
          this.setState({
            colorNotificacion: "danger",
            mensaje: data.mensaje || "Error al generar las variaciones",
          });
        } else {
          // Construir mensaje detallado
          let mensaje = data.mensaje || "Variaciones generadas correctamente";
          if (data.data) {
            if (data.data.creadas > 0) {
              mensaje = `Se generaron ${data.data.creadas} variación(es) correctamente`;
            }
            if (data.data.duplicadas > 0) {
              mensaje += `, ${data.data.duplicadas} ya existían`;
            }
            if (data.data.errores > 0) {
              mensaje += `, ${data.data.errores} tuvieron errores`;
            }
          }
          
          this.setState({
            colorNotificacion: data.data && data.data.creadas > 0 ? "success" : "warning",
            mensaje: mensaje,
          });
          
          // Cerrar el modal
          this.cerrarModalGenerarCombinaciones();
          
          // Recargar variaciones
          this.obtenerVariaciones(this.state.master._id);
        }
        this.showNotification();
      })
      .catch((err) => {
        console.error("Error al generar variaciones:", err);
        this.setState({
          generandoVariaciones: false,
          colorNotificacion: "danger",
          mensaje: "Error al generar las variaciones",
        });
        this.showNotification();
      });
  }

  bajarVariacion(variacion) {
    // Actualizar la variación con Autorizado: false
    fetch(Globales.Url + "Productos/Productos/ActualizarAutorizado", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: Globales.token,
      },
      body: JSON.stringify({
        _id: variacion._id,
        Autorizado: false,
      }),
    })
      .then((res) => res.json())
      .then((updateData) => {
        if (updateData.error) {
          this.setState({
            colorNotificacion: "danger",
            mensaje: updateData.mensaje || "Error al bajar la variación",
          });
          this.showNotification();
        } else {
          // Verificar si todas las variaciones están en false
          if (variacion.idPadre) {
            fetch(Globales.Url + "Productos/Productos/ObtenerVariaciones", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: Globales.token,
              },
              body: JSON.stringify({
                idPadre: variacion.idPadre,
              }),
            })
              .then((res) => res.json())
              .then((variacionesData) => {
                if (variacionesData.error || !variacionesData.data) {
                  this.setState({
                    colorNotificacion: "warning",
                    mensaje:
                      "Variación bajada, pero error al verificar otras variaciones",
                  });
                  this.showNotification();
                  // Recargar variaciones
                  this.obtenerVariaciones(variacion.idPadre);
                } else {
                  const todasVariaciones = variacionesData.data;
                  const todasEnFalse = todasVariaciones.every(
                    (v) => v.Autorizado === false || v.Autorizado === null
                  );

                  if (todasEnFalse) {
                    // Actualizar el master a false
                    fetch(
                      Globales.Url + "Productos/Productos/ActualizarAutorizado",
                      {
                        method: "POST",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                          Authorization: Globales.token,
                        },
                        body: JSON.stringify({
                          _id: variacion.idPadre,
                          Autorizado: false,
                        }),
                      }
                    )
                      .then((res) => res.json())
                      .then((masterUpdateData) => {
                        if (masterUpdateData.error) {
                          this.setState({
                            colorNotificacion: "warning",
                            mensaje:
                              "Variación bajada, pero error al actualizar el master",
                          });
                          this.showNotification();
                        } else {
                          this.setState({
                            colorNotificacion: "success",
                            mensaje: "Variación bajada correctamente",
                          });
                          this.showNotification();
                        }
                        // Recargar datos
                        this.obtenerMaster(variacion.idPadre);
                        this.obtenerVariaciones(variacion.idPadre);
                      })
                      .catch((err) => {
                        console.error("Error al actualizar master:", err);
                        this.setState({
                          colorNotificacion: "warning",
                          mensaje:
                            "Variación bajada, pero error al actualizar el master",
                        });
                        this.showNotification();
                        // Recargar datos de todos modos
                        this.obtenerMaster(variacion.idPadre);
                        this.obtenerVariaciones(variacion.idPadre);
                      });
                  } else {
                    // No todas están en false, solo recargar
                    this.setState({
                      colorNotificacion: "success",
                      mensaje: "Variación bajada correctamente",
                    });
                    this.showNotification();
                    // Recargar datos
                    this.obtenerMaster(variacion.idPadre);
                    this.obtenerVariaciones(variacion.idPadre);
                  }
                }
              })
              .catch((err) => {
                console.error("Error al obtener variaciones:", err);
                this.setState({
                  colorNotificacion: "warning",
                  mensaje:
                    "Variación bajada, pero error al verificar otras variaciones",
                });
                this.showNotification();
                // Recargar variaciones de todos modos
                if (variacion.idPadre) {
                  this.obtenerVariaciones(variacion.idPadre);
                }
              });
          } else {
            // No hay idPadre, solo recargar variaciones
            this.setState({
              colorNotificacion: "success",
              mensaje: "Variación bajada correctamente",
            });
            this.showNotification();
          }
        }
      })
      .catch((err) => {
        console.error("Error al actualizar variación:", err);
        this.setState({
          colorNotificacion: "danger",
          mensaje: "Error al bajar la variación",
        });
        this.showNotification();
      });
  }

  render() {
    const { classes } = this.props;
    const { master, variaciones, cargando } = this.state;

    let agregar;
    if (this.state.showAgregar == true) {
      agregar = (
        <AgregarProducto
          Titulo={this.state.Titulo}
          _id={this.state._id}
          idCategoria={this.state.idCategoria}
          NombreProducto={this.state.NombreProducto}
          TipoProducto={this.state.TipoProducto}
          Descripcion={this.state.Descripcion}
          caracteristicasAgregadas={this.state.caracteristicasAgregadas}
          atributosAgregados={this.state.atributosAgregados}
          idModelo={this.state.idModelo}
          idMateriaPrima={this.state.idMateriaPrima}
          materialesAgregados={this.state.materialesAgregados}
          CostoMaterial={this.state.CostoMaterial}
          CostoMaquila={this.state.CostoMaquila}
          TipoPrecio={this.state.TipoPrecio}
          PorcentajeUtilidad={this.state.PorcentajeUtilidad}
          PrecioPublico={this.state.PrecioPublico}
          PrecioSinIva={this.state.PrecioSinIva}
          PorcentajeComision={this.state.PorcentajeComision}
          ImporteUtilidad={this.state.ImporteUtilidad}
          Peso={this.state.Peso}
          Tamaño={this.state.Tamaño}
          Caracteristicas={this.state.Caracteristicas}
          Atributos={this.state.Atributos}
          Modelos={this.state.Modelos}
          MateriaPrima={this.state.MateriaPrima}
          Material={this.state.Material}
          UnidadMedida={this.state.UnidadMedida}
          Empresa={this.state.Empresa}
          showAgregar={this.state.showAgregar}
          eventClick={this.eventoModalProducto}
          TabIndex={this.state.TabIndex}
          ImporteComision={this.state.ImporteComision}
          IVA={this.state.IVA}
          PorcentajeUtilidadSistema={this.state.PorcentajeUtilidadSistema}
          op={this.state.op}
          NombreImagenProducto={this.state.NombreImagenProducto}
          ImagenProducto={this.state.ImagenProducto}
          NombreTempleteRecorte={this.state.NombreTempleteRecorte}
          NombreTextura={this.state.NombreTextura}
          GruposMaterial={this.state.GruposMaterial}
          idPadre={this.state.idPadre}
          esVariacion={this.state.esVariacion}
          ProductoNuevo={this.state.ProductoNuevo}
          Autorizado={this.state.Autorizado}
        />
      );
    }

    return (
      <div>
        <GridContainer justify="center">
          {cargando ? (
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer justify="center">
                <ReactLoading
                  type={"bubbles"}
                  color={"#CFCFCF"}
                  height={"10%"}
                  width={"10%"}
                />
              </GridContainer>
            </GridItem>
          ) : master ? (
            <>
              {/* Información General del Master */}
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader color="info" text>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <h4>General</h4>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        {this.state.editandoMaster ? (
                          <>
                            <Button
                              size="sm"
                              color="success"
                              round
                              className="pull-right"
                              onClick={this.guardarMaster}
                            >
                              <Save />
                              &nbsp;Guardar
                            </Button>
                            <Button
                              size="sm"
                              color="warning"
                              round
                              className="pull-right"
                              onClick={this.cancelarEdicionMaster}
                              style={{ marginRight: "10px" }}
                            >
                              <Clear />
                              &nbsp;Cancelar
                            </Button>
                          </>
                        ) : (
                          <>
                            <Button
                              size="sm"
                              color="warning"
                              round
                              className="pull-right"
                              onClick={this.editarMaster}
                              style={{ marginRight: "10px" }}
                            >
                              <Edit />
                              &nbsp;Editar
                            </Button>
                            <Button
                              size="sm"
                              color="info"
                              round
                              className="pull-right"
                              onClick={() => this.props.history.goBack()}
                            >
                              <ArrowBack />
                              &nbsp;Volver
                            </Button>
                          </>
                        )}
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    {this.state.editandoMaster ? (
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Nombre Producto"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handleChangeMaster,
                              value: this.state.NombreProductoEdit,
                              name: "NombreProductoEdit",
                              id: "NombreProductoEdit",
                              type: "text",
                            }}
                          />
                          <CustomInput
                            labelText="Descripción"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handleChangeMaster,
                              value: this.state.DescripcionEdit,
                              name: "DescripcionEdit",
                              id: "DescripcionEdit",
                              type: "text",
                            }}
                          />
                          <FormControl fullWidth className="mt-4">
                            <InputLabel>Tipo de producto</InputLabel>
                            <Select
                              value={this.state.TipoProductoEdit}
                              onChange={this.handleSimpleMaster}
                              name="TipoProductoEdit"
                              id="TipoProductoEdit"
                            >
                              <MenuItem disabled>Tipo de producto</MenuItem>
                              <MenuItem value="Estandar">Estándar</MenuItem>
                              <MenuItem value="Paquete">Paquete</MenuItem>
                            </Select>
                          </FormControl>
                          <FormControl fullWidth className="mt-4">
                            <InputLabel>Categoría</InputLabel>
                            <Select
                              value={this.state.idCategoriaEdit}
                              onChange={this.handleSimpleMaster}
                              name="idCategoriaEdit"
                              id="idCategoriaEdit"
                            >
                              <MenuItem disabled>Categoría</MenuItem>
                              {this.state.Categorias.map((m) => (
                                <MenuItem key={m._id} value={m._id}>
                                  {m.NombreCategoriaPrincipal}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <h5>Imagen del Producto</h5>
                          <input
                            id="ImagenProductoEdit"
                            name="ImagenProductoEdit"
                            className="inputfile"
                            type="file"
                            accept="image/*"
                            onChange={this.getFiles}
                          />
                          {this.state.ImagenSubida == true ? (
                            <label htmlFor="ImagenProductoEdit">
                              <Publish />
                              Subiendo &nbsp;{" "}
                              <Loader
                                style={{ float: "right" }}
                                visible={true}
                                type="Oval"
                                color="#212121"
                                height={12}
                                width={12}
                              />
                            </label>
                          ) : (
                            <label htmlFor="ImagenProductoEdit">
                              <Publish />
                              Seleccione
                            </label>
                          )}
                          {this.state.NombreImagenProductoEdit && (
                            <label
                              style={{ color: "black", marginLeft: "10px" }}
                            >
                              {this.state.NombreImagenProductoEdit}
                            </label>
                          )}
                          <div
                            style={{
                              marginTop: "20px",
                              width: "100%",
                              minHeight: "200px",
                              border: "2px dashed #ccc",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            {this.state.ImagenProductoEdit ? (
                              <img
                                id="ImagenProductoEditPreview"
                                src={this.state.ImagenProductoEdit}
                                alt="Preview"
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "300px",
                                  objectFit: "contain",
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#999",
                                  padding: "20px",
                                }}
                              >
                                <p style={{ margin: 0, fontSize: "16px" }}>
                                  Sin imagen
                                </p>
                                <p
                                  style={{
                                    margin: "5px 0 0 0",
                                    fontSize: "12px",
                                  }}
                                >
                                  Seleccione una imagen para el producto
                                </p>
                              </div>
                            )}
                          </div>
                        </GridItem>
                      </GridContainer>
                    ) : (
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                          <p>
                            <strong>Nombre:</strong> {master.NombreProducto}
                          </p>
                          <p>
                            <strong>Tipo:</strong> {master.TipoProducto}
                          </p>
                          <p>
                            <strong>Descripción:</strong> {master.Descripcion}
                          </p>
                          <p>
                            <strong>Materia Prima:</strong>{" "}
                            {this.obtenerNombreMateriaPrima(
                              master.idMateriaPrima
                            )}
                          </p>
                          <p>
                            <strong>Precio Público:</strong> $
                            {master.PrecioPublico || "N/A"}
                          </p>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <p>
                            <strong>Imagen del Producto:</strong>
                          </p>
                          <div
                            style={{
                              width: "100%",
                              minHeight: "200px",
                              border: "2px dashed #ccc",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f9f9f9",
                              marginTop: "10px",
                            }}
                          >
                            {(() => {
                              // Priorizar rutaImagenPublica, luego ImagenProducto
                              const imagenUrl = master.rutaImagenPublica
                                ? master.rutaImagenPublica
                                : master.ImagenProducto
                                ? master.ImagenProducto.startsWith("data:")
                                  ? master.ImagenProducto
                                  : "data:image/png;base64," +
                                    master.ImagenProducto
                                : null;

                              if (imagenUrl) {
                                return (
                                  <img
                                    src={imagenUrl}
                                    alt="Producto"
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "300px",
                                      objectFit: "contain",
                                    }}
                                  />
                                );
                              }

                              return (
                                <div
                                  style={{
                                    textAlign: "center",
                                    color: "#999",
                                    padding: "20px",
                                  }}
                                >
                                  <p style={{ margin: 0, fontSize: "16px" }}>
                                    Sin imagen
                                  </p>
                                  <p
                                    style={{
                                      margin: "5px 0 0 0",
                                      fontSize: "12px",
                                    }}
                                  >
                                    No hay imagen disponible para este producto
                                  </p>
                                </div>
                              );
                            })()}
                          </div>
                        </GridItem>
                      </GridContainer>
                    )}
                  </CardBody>
                </Card>
              </GridItem>

              {/* Información de Precio del Master */}
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader color="info" text>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <h4>Precio</h4>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        {this.state.editandoPrecio ? (
                          <>
                            <Button
                              size="sm"
                              color="success"
                              round
                              className="pull-right"
                              onClick={this.guardarPrecio}
                            >
                              <Save />
                              &nbsp;Guardar
                            </Button>
                            <Button
                              size="sm"
                              color="warning"
                              round
                              className="pull-right"
                              onClick={this.cancelarEdicionPrecio}
                              style={{ marginRight: "10px" }}
                            >
                              <Clear />
                              &nbsp;Cancelar
                            </Button>
                          </>
                        ) : (
                          <Button
                            size="sm"
                            color="warning"
                            round
                            className="pull-right"
                            onClick={this.editarPrecio}
                          >
                            <Edit />
                            &nbsp;Editar
                          </Button>
                        )}
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    {this.state.editandoPrecio ? (
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Precio Público (IVA incluido)"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handlePrecioPublicoEdit,
                              value: this.state.PrecioPublicoEdit,
                              name: "PrecioPublicoEdit",
                              id: "PrecioPublicoEdit",
                              type: "text",
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Valor IVA"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handleChangePrecio,
                              value: this.state.valorIvaEdit,
                              name: "valorIvaEdit",
                              id: "valorIvaEdit",
                              type: "text",
                              disabled: true,
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Precio Sin IVA"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handleChangePrecio,
                              value: this.state.PrecioSinIvaEdit,
                              name: "PrecioSinIvaEdit",
                              id: "PrecioSinIvaEdit",
                              type: "text",
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Porcentaje Comisión"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              onChange: this.handleChangePrecio,
                              value: this.state.PorcentajeComisionEdit,
                              name: "PorcentajeComisionEdit",
                              id: "PorcentajeComisionEdit",
                              type: "number",
                            }}
                          />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <CustomInput
                            labelText="Importe Comisión"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              disabled: true,
                              value: this.state.ImporteComisionEdit,
                              name: "ImporteComisionEdit",
                              id: "ImporteComisionEdit",
                              type: "number",
                            }}
                          />
                        </GridItem>
                      </GridContainer>
                    ) : (
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                          <p>
                            <strong>Precio Público (IVA incluido):</strong> $
                            {master.PrecioPublico || "N/A"}
                          </p>
                          <p>
                            <strong>Precio Sin IVA:</strong> $
                            {master.PrecioSinIva || "N/A"}
                          </p>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                          <p>
                            <strong>Valor IVA:</strong> {master.IVA || "N/A"}
                          </p>
                          <p>
                            <strong>Porcentaje Comisión:</strong>{" "}
                            {master.PorcentajeComision || "N/A"}%
                          </p>
                          <p>
                            <strong>Importe Comisión:</strong> $
                            {master.ImporteComision || "N/A"}
                          </p>
                        </GridItem>
                      </GridContainer>
                    )}
                  </CardBody>
                </Card>
              </GridItem>

              {/* Tabla de Variaciones */}
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                  <CardHeader color="info">
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <h4 className="pull-left">
                          Variaciones ({variaciones.length})
                        </h4>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <div className="pull-right">
                          <Button
                            size="sm"
                            color="info"
                            round
                            className="pull-right"
                            onClick={this.abrirModalGenerarCombinaciones}
                            style={{ marginLeft: "10px" }}
                          >
                            <AddCircle />
                            &nbsp;Generar Combinaciones
                          </Button>
                          <Button
                            size="sm"
                            color="success"
                            round
                            className="pull-right"
                            onClick={this.crearVariacion}
                          >
                            <AddCircle />
                            &nbsp;Nueva Variación
                          </Button>
                        </div>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <CardBody>
                    {variaciones.length === 0 ? (
                      <GridContainer justify="center">
                        <GridItem>
                          <h5>No hay variaciones registradas</h5>
                        </GridItem>
                      </GridContainer>
                    ) : (
                      <div className="table-wrapper-scroll-y">
                        <table className="col-xs-12 col-sm-12 col-md-12">
                          <thead>
                            <th className="center">Nombre</th>
                            <th className="center">Variación</th>
                            <th className="center">Materia Prima</th>
                            <th className="center">Precio Público</th>
                            <th className="center">Disponible</th>
                            <th className="pull-right">Acciones</th>
                          </thead>
                          <tbody>
                            {variaciones.map((variacion) => {
                              return (
                                <tr key={variacion._id}>
                                  <td>{variacion.NombreProducto}</td>
                                  <td>{variacion.NombreTalla}</td>
                                  <td>
                                    {this.obtenerNombreMateriaPrima(
                                      variacion.idMateriaPrima
                                    )}
                                  </td>
                                  <td>${variacion.PrecioPublico || "N/A"}</td>
                                  <td>
                                    {variacion.Autorizado === true
                                      ? "Si"
                                      : "No"}
                                  </td>
                                  <td className="pull-right">
                                    <Tooltip
                                      id="edit1"
                                      title="Editar"
                                      placement="top"
                                      classes={{
                                        tooltip: classes.tooltip,
                                      }}
                                    >
                                      <Button
                                        color="warning"
                                        round
                                        justIcon
                                        size="sm"
                                        onClick={() =>
                                          this.editarVariacion(variacion)
                                        }
                                        style={{ marginRight: "5px" }}
                                      >
                                        <Edit />
                                      </Button>
                                    </Tooltip>
                                    {variacion.Autorizado === true ? (
                                      <Tooltip
                                        id="bajar1"
                                        title="Bajar"
                                        placement="top"
                                        classes={{
                                          tooltip: classes.tooltip,
                                        }}
                                      >
                                        <Button
                                          color="danger"
                                          round
                                          justIcon
                                          size="sm"
                                          onClick={() =>
                                            this.bajarVariacion(variacion)
                                          }
                                        >
                                          <GetApp />
                                        </Button>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        id="publicar1"
                                        title="Publicar"
                                        placement="top"
                                        classes={{
                                          tooltip: classes.tooltip,
                                        }}
                                      >
                                        <Button
                                          color="success"
                                          round
                                          justIcon
                                          size="sm"
                                          onClick={() =>
                                            this.publicarVariacion(variacion)
                                          }
                                        >
                                          <Publish />
                                        </Button>
                                      </Tooltip>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </GridItem>
            </>
          ) : (
            <GridItem xs={12} sm={12} md={12}>
              <GridContainer justify="center">
                <GridItem>
                  <h5>No se encontró el producto master</h5>
                </GridItem>
              </GridContainer>
            </GridItem>
          )}
        </GridContainer>
        {agregar}
        
        {/* Modal de Generación de Combinaciones */}
        <Modal
          isOpen={this.state.showModalGenerarCombinaciones}
          toggle={this.cerrarModalGenerarCombinaciones}
          size="xl"
          style={{ maxWidth: "1400px" }}
        >
          <ModalHeader toggle={this.cerrarModalGenerarCombinaciones}>
            Generar Variaciones por Combinaciones
          </ModalHeader>
          <ModalBody style={{ padding: "20px" }}>
            <GridContainer>
              {/* Columna Izquierda: Selección de Atributos */}
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="info">
                    <h5 style={{ margin: 0 }}>Atributos</h5>
                  </CardHeader>
                  <CardBody>
                    {this.state.atributosSeleccionados.length === 0 ? (
                      <p style={{ color: "#999", fontStyle: "italic", textAlign: "center", padding: "20px" }}>
                        No hay atributos disponibles para esta categoría
                      </p>
                    ) : (
                      <div style={{ maxHeight: "550px", overflowY: "auto", paddingRight: "10px" }}>
                        {this.state.atributosSeleccionados.map((atributo) => (
                          <Card key={atributo.idAtributo} style={{ marginBottom: "15px" }}>
                            <CardBody>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={atributo.seleccionado}
                                    onChange={() => this.toggleAtributoSeleccionado(atributo.idAtributo)}
                                    color="primary"
                                  />
                                }
                                label={
                                  <strong style={{ fontSize: "16px" }}>
                                    {atributo.NombreAtributo}
                                  </strong>
                                }
                              />
                              
                              {atributo.seleccionado && (
                                <div style={{ marginTop: "15px", marginLeft: "35px" }}>
                                  {atributo.valoresDisponibles.length === 0 ? (
                                    <p style={{ color: "#999", fontStyle: "italic", fontSize: "14px" }}>
                                      Este atributo no tiene valores disponibles
                                    </p>
                                  ) : (
                                    <div>
                                      <p style={{ marginBottom: "10px", fontSize: "14px", color: "#666" }}>
                                        Selecciona los valores:
                                      </p>
                                      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                                        {atributo.valoresDisponibles.map((valorObj, index) => {
                                          const valor = valorObj.valor || valorObj.label;
                                          const estaSeleccionado = atributo.valoresSeleccionados.includes(valor);
                                          
                                          return (
                                            <FormControlLabel
                                              key={index}
                                              control={
                                                <Checkbox
                                                  checked={estaSeleccionado}
                                                  onChange={() => this.toggleValorAtributo(atributo.idAtributo, valor)}
                                                  color="primary"
                                                  size="small"
                                                />
                                              }
                                              label={
                                                <span style={{ fontSize: "14px" }}>
                                                  {valorObj.label || valor}
                                                </span>
                                              }
                                            />
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </CardBody>
                          </Card>
                        ))}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </GridItem>
              
              {/* Columna Derecha: Preview de Combinaciones */}
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="info">
                    <h5 style={{ margin: 0 }}>Preview de Combinaciones</h5>
                  </CardHeader>
                  <CardBody>
                    {this.state.combinacionesPreview.length === 0 ? (
                      <div style={{ 
                        textAlign: "center", 
                        padding: "40px 20px",
                        color: "#999",
                        fontStyle: "italic"
                      }}>
                        <p style={{ fontSize: "16px", marginBottom: "10px" }}>
                          Selecciona atributos y valores
                        </p>
                        <p style={{ fontSize: "14px" }}>
                          para ver el preview de las combinaciones
                        </p>
                      </div>
                    ) : (
                      <div>
                        <div style={{ 
                          marginBottom: "15px", 
                          padding: "12px",
                          backgroundColor: "#e3f2fd",
                          borderRadius: "4px",
                          textAlign: "center"
                        }}>
                          <p style={{ margin: 0, fontSize: "18px", fontWeight: "bold", color: "#1976d2" }}>
                            Se generarán <span style={{ color: "#00acc1", fontSize: "20px" }}>{this.state.combinacionesPreview.length}</span> variación(es)
                          </p>
                        </div>
                        <div style={{ 
                          maxHeight: "500px", 
                          overflowY: "auto",
                          border: "1px solid #e0e0e0",
                          borderRadius: "4px",
                          padding: "15px",
                          backgroundColor: "#f9f9f9"
                        }}>
                          {this.state.combinacionesPreview.map((combinacion, index) => {
                            const atributosCombinacion = Object.values(combinacion);
                            return (
                              <div 
                                key={index}
                                style={{
                                  padding: "12px",
                                  marginBottom: "10px",
                                  backgroundColor: "#fff",
                                  borderRadius: "4px",
                                  border: "1px solid #e0e0e0",
                                  boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                }}
                              >
                                <span style={{ fontWeight: "bold", marginRight: "8px", color: "#666" }}>
                                  {index + 1}.
                                </span>
                                {atributosCombinacion.map((attr, idx) => (
                                  <span key={idx} style={{ fontSize: "14px" }}>
                                    <strong style={{ color: "#3c4858" }}>{attr.NombreAtributo}:</strong> 
                                    <span style={{ color: "#00acc1", marginLeft: "4px" }}>{attr.valor}</span>
                                    {idx < atributosCombinacion.length - 1 && (
                                      <span style={{ margin: "0 8px", color: "#999" }}>|</span>
                                    )}
                                  </span>
                                ))}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={this.cerrarModalGenerarCombinaciones}
            >
              Cancelar
            </Button>
            <Button
              color="primary"
              disabled={this.state.combinacionesPreview.length === 0 || this.state.generandoVariaciones}
              onClick={this.generarVariacionesMasivas}
            >
              {this.state.generandoVariaciones ? (
                <>
                  <ReactLoading
                    type="spin"
                    color="#fff"
                    height={16}
                    width={16}
                    style={{ display: "inline-block", marginRight: "8px" }}
                  />
                  Generando...
                </>
              ) : (
                `Generar Variaciones (${this.state.combinacionesPreview.length})`
              )}
            </Button>
          </ModalFooter>
        </Modal>
        
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(headerLinksStyle)(DetalleProductoMaster);
